import moment from 'moment-timezone';

// A local hint only: goserver derives the real category from the request time under the
// rules in force.
export const TEACHER_CANCEL_BUCKET_OPTIONS = [
  { value: 'OUTSIDE_24H', label: 'More than 24h before start' },
  { value: 'WITHIN_24_1H', label: '24h–1h before start' },
  { value: 'WITHIN_1H_OR_AFTER', label: 'Less than 1h before / after start' }
];

// Hint bucket at the default 24h/1h cut-offs; seconds-based >= so exact 24h/1h land in the
// earlier bucket, like the engine.
export function derive_cancel_bucket(session_start_epoch, requested_at_local, iana_timezone) {
  if (
    session_start_epoch === undefined ||
    session_start_epoch === null ||
    session_start_epoch === ''
  )
    return '';
  const requested = moment.tz(requested_at_local, iana_timezone);
  if (!requested_at_local || !requested.isValid()) return '';
  const secs = moment(session_start_epoch).diff(requested, 'seconds');
  if (secs >= 24 * 3600) return 'OUTSIDE_24H';
  if (secs >= 3600) return 'WITHIN_24_1H';
  return 'WITHIN_1H_OR_AFTER';
}

// Mirrors apis: a request time more than 2 minutes past now is rejected (clock-skew tolerance).
export const REQUESTED_AT_CLOCK_SKEW_MS = 2 * 60 * 1000;
export const REQUESTED_AT_IN_FUTURE = "Requested at can't be in the future";

export function is_requested_at_in_future(requested_at_local, iana_timezone, now_ms) {
  const iso = requested_at_to_iso(requested_at_local, iana_timezone);
  return !!iso && moment(iso).valueOf() > now_ms + REQUESTED_AT_CLOCK_SKEW_MS;
}

// Plain-words category for a bucket ('' when none).
export function cancel_bucket_label(bucket) {
  const option = TEACHER_CANCEL_BUCKET_OPTIONS.find((o) => o.value === bucket);
  return option ? option.label : '';
}

export const CANCEL_BUCKET_HINT = 'The final category follows the current cancellation rules.';

// The hint line under the time field; says the category is only expected, not final.
export function cancel_bucket_text({ category, ownsTimeField, timeFieldNote, categoryNote }) {
  if (!category) {
    return `Category: set from the request time${ownsTimeField ? '' : ` (${timeFieldNote})`}`;
  }
  const note = categoryNote ? ` (${categoryNote})` : '';
  return `Expected category: ${category}${note}. ${CANCEL_BUCKET_HINT}`;
}

// datetime-local value read in iana_timezone, as a UTC ISO string ('' when empty or malformed).
export function requested_at_to_iso(requested_at_local, iana_timezone) {
  if (!requested_at_local) return '';
  const m = moment.tz(requested_at_local, iana_timezone);
  return m.isValid() ? m.toISOString() : '';
}
